import { MedewerkerType } from "../../../../enums";
import { getRoleDisplayName } from "../../../../services/dossierEmployeesService";
import { getRoleSortIndex } from "../../../employees/roleUtils";

/**
 * B6: de functie(s) waarmee iemand op dit dossier zit, als korte tekst achter
 * de naam in de keuzelijst ("Arts, Project Manager"). Geen functie: undefined,
 * dan toont de lijst niets.
 */
export function functiesOpDossier(rollen: string[]): string | undefined {
  if (rollen.length === 0) return undefined;
  return [...rollen]
    .sort((a, b) => getRoleSortIndex(a) - getRoleSortIndex(b))
    .map((rol) => getRoleDisplayName(rol as MedewerkerType))
    .join(", ");
}

/**
 * D11: functies die aanvullende vragen uitwerken. Dezelfde set als de omzetting
 * van Reactie OG in migratie 20261012170100_reactie_og_splitsen.
 */
const UITWERKENDE_FUNCTIES: readonly string[] = [
  MedewerkerType.ARTS,
  MedewerkerType.ASSISTENT,
  MedewerkerType.WAARNEMEND_ASSISTENT,
];

/** True als iemand met deze functies op het dossier arts of assistent is. */
export function werktAanvullendeVragenUit(rollen: string[]): boolean {
  return rollen.some((rol) => UITWERKENDE_FUNCTIES.includes(rol));
}
